import { EventEmitter } from "@stencil/core";

export interface AdobeAnalyticsUpdate {
    intel: any;
};


export function addAdobeAnalyticsUpdateToDatalayer(
    adobeAnalyticsUpdate: AdobeAnalyticsUpdate,
    chatbotButtonUpdate: EventEmitter,
    adobeUpdateDaan: EventEmitter,
    buttonEvent = false
) {
    if (adobeAnalyticsUpdate !== null) {
        if (buttonEvent && !!chatbotButtonUpdate) {
            chatbotButtonUpdate.emit();
        } else if (!!adobeUpdateDaan){
            adobeUpdateDaan.emit();
        }

        if (adobeAnalyticsUpdate.intel !== null) {
            document.body.dispatchEvent(
                new CustomEvent('postnl-datalayer-event', {
                    detail: adobeAnalyticsUpdate.intel,
                })
            );
        }
    }
}